import PropTypes from "prop-types";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const AuthHandlerAdmin = ({ children }) => {
  const storedData = JSON.parse(localStorage.getItem("tokenSession"));

  if (storedData?.access_token && storedData?.user?.type === "admin") {
    return children;
  } else {
    return <Redirect to="/identify" />;
  }
};
AuthHandlerAdmin.propTypes = {
  children: PropTypes.object,
};

export default AuthHandlerAdmin;
